<!--  -->
<template>
  <div class="timeItem" :class="isRow?'longWidth':''">
    <el-form
      :model="dateForm"
      :rules="rules"
      ref="dateForm"
      label-width="100px"
      class="demo-ruleForm"
      :class="isRow?'grace-flex-0-center':''"
    >
      <el-form-item :label="title + ':'" prop="dateValue" v-if="type!='look'">
        <el-date-picker
          v-model="dateForm.dateValue"
          type="datetimerange"
          start-placeholder="选择时间范围"
          @change="handleChange()"
        >
        </el-date-picker>
      </el-form-item>
      <div class="showTime grace-space-around-center" :class="type=='look'?'long':''" v-if="show.length > 1">
        <div v-if="type=='look'" class="title">{{title}}</div>
        <div class="showItem grace-columns">
          <div class="date">
            <span>{{ show[0].date }}</span>
            <span>周{{ show[0].week | getweek }}</span>
          </div>
          <div class="hour">{{ show[0].hour }}</div>
          <div class="desc">开始时间</div>
        </div>
        <div class="gan">-</div>
        <div class="showItem grace-columns">
          <div class="date">
            <span>{{ show[1].date }}</span>
            <span>周{{ show[1].week | getweek }}</span>
          </div>
          <div class="hour">{{ show[1].hour }}</div>
          <div class="desc">开始时间</div>
        </div>
      </div>
    </el-form>
  </div>
</template>

<script>
import filter from "@/filter";
export default {
  props: {
    title: "",
    time: "",
    isRow: false,
    type: ""
  },
  data() {
    return {
      dateForm: {
        dateValue: '',
      },
      show: [],
      rules: {
        dateValue: {
          required: true,
          message: "请输入" + this.title,
          trigger: "blur",
        },
      },
    };
  },
  filters: {
    getweek(e) {
      var week = ["一", "二", "三", "四", "五", "六", "日"];
      return week[e - 1];
    },
  },
  //   watch:{
  //     time(val){
  //         console.log(val)
  //       this.dateForm.dateValue = val
  //     }
  //   },
  components: {},

  computed: {},

  mounted() {
    this.$set(this.dateForm,'dateValue',this.time)
    console.log('dateValue---:',this.dateForm.dateValue)
    this.handleChange();
  },

  methods: {
    handleChange() {
      console.log(this.dateForm.dateValue);
      if (this.dateForm.dateValue && this.dateForm.dateValue.length > 0) {
        let arr = this.dateForm.dateValue.map((item) => {
          let obj = {};
          let t = filter.formatDate4(item);
          obj.date = t.slice(5, 11);
          obj.hour = t.slice(12, 17);
          obj.week = filter.formatDate7(item);
          return obj;
        });
        console.log(arr);
        this.show = arr;
      }else{
          this.show = []
      }

      this.$emit("setTime", this.dateForm.dateValue);
    },
    setEditTime(val) {
      console.log("val:", val);
      this.$set(this.dateForm,'dateValue',val)
    },
    check() {
      return new Promise((resolve, reject) => {
        this.$refs.dateForm.validate((valid) => {
          if (valid) {
            resolve(true);
          } else {
            reject(false);
          }
        });
      });
    },
    reset() {
      console.log("reset--------");
    //   this.dateForm.dateValue = "";
      this.$set(this.dateForm,'dateValue',[])
      this.show = [];
      this.$refs.dateForm && this.$refs.dateForm.resetFields();
    },
  },
};
</script>
<style lang="scss" scoped>
.timeItem {
  width: 370px;
  /deep/ .el-form {
    width: 370xp;
    .el-date-editor--datetimerange.el-input__inner {
      width: 220px;
    }
  }
}
.longWidth{
    width: 100%;
}
.showTime {
  width: 260px;
  margin: 0 auto;
  .showItem {
    color: #409eff;
    text-align: center;
    .date {
      font-size: 14px;
    }
    .hour {
      font-size: 36px;
      font-weight: bold;
    }
    .desc {
      width: 80px;
      height: 25px;
      line-height: 25px;
      color: #999999;
      font-size: 12px;
      text-align: center;
      border-radius: 13px;
      background: #f2f2f2;
    }
  }
  .gan {
    line-height: 85px;
    color: #409eff;
    font-size: 36px;
    font-weight: bold;
  }
}
.long{
  width: 370px;
  .title{
    font-size: 14px;
  }
}
/deep/ .el-picker-panel {
  .el-input {
    width: 100px !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/DatePicker.vue